/* eslint no-eval: 0 */
import React, {Fragment, useState } from 'react';
import {KTSVG} from '../../../_metronic/helpers'
import {FormikProps} from 'formik'
import CustomInput from './CustomInput'

interface FormWrapperProps {
    items: any // don't have to redeclare the object again
    formikProps: FormikProps<any>
    showGroupLabel?: boolean
    delta?: number,
    form_name: string,
    state_modal?: any
};

const BuilderForm: React.FC<FormWrapperProps> = (props) => {
    const current = window.FormSettings[props.form_name][props.items]
    
    const [delta, setDelta] = useState(0)
    
    /*const loadLastItem = (element: any) => {
	    let nb_element = window.FormSettings[props.form_name][props.items].subform.length;
	    return window.FormSettings[props.form_name][props.items].subform[nb_element - 1]
	}*/
	
    const addItem = (element: any) => {
	    
	    let nb_element = window.FormSettings[props.form_name][props.items].subform.length;
	    //loadLastItem(element)
	     var next = Object.assign({}, window.FormSettings[props.form_name][props.items].subform[nb_element - 1])
	    
	    window.FormSettings[props.form_name][props.items].subform.push(next)
	    
	    ////CHEC IF SUFORM CHILD
	    Object.keys(window.FormSettings[props.form_name][props.items].subform[nb_element].structure).forEach((subfield, k) => {
		    //GROUP MAIN
		    if(window.FormSettings[props.form_name][subfield].children){
			    
			    var new_group_main_name = subfield + "_" + nb_element
			    
			    var new_group_mail = Object.assign({},window.FormSettings[props.form_name][subfield])
			    window.FormSettings[props.form_name][new_group_main_name] = new_group_mail
			    
			    //EACH FIELD
			    if(window.FormSettings[props.form_name][subfield].children){
				    
				    ToArray(window.FormSettings[props.form_name][subfield].children).forEach((child_name, i) => {
					    var child = Object.assign({}, window.FormSettings[props.form_name][child_name])
						
						//IF SUBFORM
						if(child.subform){
							
							console.log("1/ child subform", child, child.subform)
							
							child.name = child.name.replace(props.items + "." + (nb_element - 1), props.items + "." + (nb_element))
							
							window.FormSettings[props.form_name][child.name] = child
						
							console.log("child subform", child)
							Object.values(child.subform).forEach((subform: any, delta_subform_child: any) => {
								
								if(subform.structure && delta_subform_child === 0){
									
									
									var new_structure : any = {}
									
									Object.keys(subform.structure).forEach((subgroup, u) => {
										var new_children: any = []
										
										var new_group_name = subgroup + "_" + nb_element + "_" + delta_subform_child
										
										console.log("SUBGROUP", subgroup, new_group_name, window.FormSettings[props.form_name][subgroup])
										
										ToArray(window.FormSettings[props.form_name][subgroup].children).forEach((child_field, field_id) => {
											
											//DUPLICATE FIELD
											var child_field_element = Object.assign({}, window.FormSettings[props.form_name][child_field])
											
											var new_parent_name = child_field_element.parent_name.replace(props.items + "." + (nb_element - 1), props.items + "." + (nb_element))
											
											child_field_element.name = child_field_element.name.replace(child_field_element.parent_name, new_parent_name)
											child_field_element.parent_name = new_parent_name
											
											window.FormSettings[props.form_name][child_field_element.name] = child_field_element
											
											new_children.push(child_field_element.name)
											
											
											console.log("props.items", props.items)
											console.log("nb_element", nb_element)
											console.log("delta_subform_child", delta_subform_child)
											console.log("child_field_base", window.FormSettings[props.form_name][child_field])
											console.log("child_field_element", child_field_element)
										})
										
										window.FormSettings[props.form_name][new_group_name] = Object.assign({}, window.FormSettings[props.form_name][subgroup])
										window.FormSettings[props.form_name][new_group_name].children = new_children
										
										new_structure[new_group_name] = window.FormSettings[props.form_name][new_group_name]
										
										console.log("window.FormSettings[props.form_name][new_group_name]", new_group_name, window.FormSettings[props.form_name][new_group_name])
									
										
									})
									
									console.log("new_structure", subform, subform.structure, new_structure)
									
									var new_subform = Object.assign({}, subform)
									new_subform.structure = new_structure
									
									var new_group_children : any = []
									Object.values(window.FormSettings[props.form_name][new_group_main_name].children).forEach((childname: any, c: any) => {
										console.log("childname",childname)
										var nname = childname.replace(props.items + "." + (nb_element - 1), props.items + "." + (nb_element))
										new_group_children.push(nname)
										
										//DUPLICATE CONFIG
										if(typeof window.FormSettings[props.form_name][nname] == "undefined"){
											var el = Object.assign({},window.FormSettings[props.form_name][childname])
											window.FormSettings[props.form_name][nname] = el
											window.FormSettings[props.form_name][nname].name = window.FormSettings[props.form_name][nname].name.replace(props.items + "." + (nb_element - 1), props.items + "." + (nb_element))
										}
										
									})
									window.FormSettings[props.form_name][new_group_main_name].children = new_group_children
									
									console.log("NEW GROUP", new_group_main_name, new_group_children, window.FormSettings[props.form_name][new_group_main_name])
									
									
									window.FormSettings[props.form_name][props.items].subform[nb_element].structure = {}
									window.FormSettings[props.form_name][props.items].subform[nb_element].structure[new_group_main_name] = window.FormSettings[props.form_name][new_group_main_name]
									
									window.FormSettings[props.form_name][child.name].subform = [new_subform]
									
										console.log("GLOBAL", new_group_main_name, window.FormSettings[props.form_name][props.items].subform)
									
										console.log("GLFRINOBAL", window.FormSettings[props.form_name])
									
								}
							})
						}
				    })
				}
			}
		})
	    setDelta(delta+1);
    }
    
    const removeItem = (parent_element: any, index: any) => {
	    
	    console.log("removeItem", props.items, parent_element, index)
	    	
	    	if(props.formikProps.initialValues[props.items]){
		    	
			    //REMOVE VALUES
			    props.formikProps.initialValues[props.items][index] = {}
		    	
	    	}else{
		    	
		    	//DYNAMIQUE REMOVE
		    	
		    	var name_eval = "props.formikProps.initialValues"
	            var name_parts = props.items[0].split('.')
	            
	            console.log("name_parts", name_parts)
	            
	            if(name_parts.length > 1){
	            //	console.log("name_parts", name_parts, parent_field, parent_delta, cleanedInitValue)
	            }
	            
	            //INIT
	            name_parts.forEach((parts: any)=>{
		            
		            if(isNaN(parts)){
		            	name_eval += "['" + parts +  "']"
		            }else{
			            name_eval += "[" + parts +  "]"
		            }
		            /*
		            var eval_code = "if(typeof "+name_eval+" === 'undefined'){"
		            eval_code += name_eval + " = {}"
		            eval_code += '}'
					eval(eval_code)
					*/
					
	            })
	            
	            	
				console.log(name_eval)
				
				 //REMOVE VALUES
	            eval(name_eval + "[index] =  {}")
            
            }
            
	    
	    //DELETE PARA
	    window.FormSettings[props.form_name][props.items].subform[index] = undefined 
	    
	    
	    setDelta(delta - 1);
    }

	//console.log("BuilderForm", props)

    return (
        <Fragment>
            {typeof current?.children !== "undefined" && current?.children.length > 0 ? (
                <>
                    {checkChildren(current, props.formikProps, props.form_name) ? (
                        <div className='fv-row'>
                            <div className='row'>
                                {ToArray(current.children).map((child, i) => (
                                    <BuilderForm key={i} items={[child.toString()]} formikProps={props.formikProps} form_name={props.form_name} delta={props.delta} state_modal={props.state_modal}  />
                                ))}
                            </div>
                        </div>
                    ):null}
                </>

            ) : typeof current?.subform !== 'undefined' ?(
                <div className='fv-row border mb-5 pt-5 px-10 subform'>
                    <div className='row'>
                        <h4 className='mb-3 p-0 d-flex justify-content-between align-items-center'>{current.title}
                            <button value='toggle'
                            	type="button"
                            	className='togglebutton border-0 bg-transparent text-primary me-3'
                            	onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
									event.preventDefault();
									let dataValue = (event.target as HTMLElement);
									if (dataValue && dataValue.nodeName === "BUTTON" ){
										let ui = dataValue.children;
										for (var i = 0; i < ui.length; i++) {
											ui[i].classList!.toggle('d-none');
										}
										dataValue.parentElement!.nextElementSibling!.classList!.toggle("d-none");
									};
						        }}>
								<span className="pe-none">+</span>
								<span className="pe-none d-none">-</span>
                            </button>

                        </h4>
						<div className='d-none'>
							{Object.values(current?.subform).map((field_delta: any, delta)=>
								<Fragment key={delta}>
									{typeof field_delta != "undefined" ? (

										<div className={delta !== current?.subform.length -1 ? 'border-bottom mb-5': ''}>

											{Object.keys(field_delta.structure).map((subfield, k) => (
												<BuilderForm key={k} items={[subfield.toString()]} form_name={props.form_name} formikProps={props.formikProps} delta={delta} state_modal={props.state_modal}/>
											))}
											<>
												{current?.subform.length > 1 ? (
													<>
														<button value='remove'
																type="button"
																className='rmvbutton btn btn-sm btn-link'
																onClick={(event) => {
																	removeItem(current, delta);
																}}>
						                                    <span>
						                                        <KTSVG
																	path='/media/icons/duotune/arrows/arr061.svg'
																	className='svg-icon-1 svg-icon-primary'
																/>
						                                        Remove
						                                    </span>
														</button>
													</>
												): null }
											</>

										</div>
									) : null }
								</Fragment>
							)}
							<button value='add'
									type="button"
									className='btn btn-sm btn-primary mt-2 me-3 mb-4'
									onClick={(event) => {
										addItem(current);
									}}>
		                            <span>
		                                <KTSVG
											path='/media/icons/duotune/arrows/arr075.svg'
											className='svg-icon-1 svg-icon-primary'
										/>
		                                Add { current.title}
		                            </span>
							</button>
						</div>
                    </div>
                </div>
            ):(
                <CustomInput element={props.items} formikProps={props.formikProps} delta={props.delta} form_name={props.form_name} state_modal={props.state_modal}/>
            )}
        </Fragment>
    );
};

	
	

function checkChildren(group: any, formikProps: any, form_name: string){
 
    let isVisible = false
    group.children.forEach((field_name: any)=>{
        const element = window.FormSettings[form_name][field_name]
        if(typeof element?.states !== 'undefined' && element.states){
	        var i = 0
	        //CHECK ALL #STATES (ccategorie, checkbox..;)
	        var elementVisible = true
			Object.values(element.states).forEach((state: any)=>{
	            var target_field_value = Number(formikProps.values[Object.keys(element.states)[i]])
	            var condition_target_field_value : any = Object.values(element.states)[i]
	            if(!condition_target_field_value.includes(target_field_value)){
	                elementVisible = false
	            }
	            i++
	            
            })
            
            if(elementVisible){
            	isVisible = true
	            return isVisible
	        }
            
        }
        else{
            isVisible = true
            return isVisible
        }
    })
    return isVisible
}
	
/*
	
ANCIEN : AVANT MULTIPLE SATTE
	
function checkChildren(group: any, formikProps: any, form_name: string){
 
    let isVisible = false
    group.children.forEach((field_name: any)=>{
        const element = window.FormSettings[form_name][field_name]
        if(typeof element?.states !== 'undefined' && element.states){
            var target_field_value = Number(formikProps.values[Object.keys(element.states)[0]])
            var condition_target_field_value : any = Object.values(element.states)[0]
            if(condition_target_field_value.includes(target_field_value)){
                isVisible = true
                return isVisible
            }
        }
        else{
            isVisible = true
            return isVisible
        }
    })
    return isVisible
}
*/

function ToArray(obj : object){
    return Object.values(obj)
}

export default BuilderForm;
export {ToArray, checkChildren};